// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__S1cwN","imageWrapper":"imageWrapper__1hgxI","sdg_image":"sdg_image__3wpLj","list":"list__2zxsI","value":"value__2F4zH","label":"label__wOqKs","mapContainer":"mapContainer__3qlMn","disclaimer":"disclaimer__hEOfY","chartWrapper":"chartWrapper__33Wcv","recipient_themes_wrapper":"recipient_themes_wrapper__1AcqZ","budget_percent":"budget_percent__3yvju","top_budget_sources_wrapper":"top_budget_sources_wrapper__19_sn","chartHead":"chartHead__2KX5T","infoWrapper":"infoWrapper__1K0g1","tableWrapper":"tableWrapper__RG7JM","titleWrapper":"titleWrapper__22GrA","backButtonTop":"backButtonTop__3n25V"};


//////////////////
// WEBPACK FOOTER
// ./routes/embedViews/paLanding/style.scss
// module id = RTlb
// module chunks = 0